import React, { useEffect, useState } from 'react';
import httpService from '../services/httpService';
import { ApiResponse } from '../types/common';

// Define the interface locally based on the actual API response provided by the user
interface Device {
  deviceId: number;
  deviceName: string;
  imageBase64: string | null;
  description: string | null;
}

const ServiceCategories: React.FC = () => {
  const [devices, setDevices] = useState<Device[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDevices = async () => {
      try {
        const response = await httpService.get<ApiResponse<Device[]>>('device');

        console.log('ServiceCategories API Response:', response);

        if (response && Array.isArray(response.data)) {
          setDevices(response.data);
        } else {
          console.warn('API response structure unexpected:', response);
          setDevices([]);
        }
      } catch (error) {
        console.error('Error fetching devices:', error);
        setDevices([]);
      } finally {
        setLoading(false);
      }
    };

    fetchDevices();
  }, []);

  if (loading) {
    return null;
  }

  if (devices.length === 0) {
    return null;
  }

  return (
    <section className="py-12 sm:py-16 bg-white overflow-hidden">
      <div className="container mx-auto max-w-7xl px-4 sm:px-6">
        {/* Header Section */}
        <div className="text-center mb-10 sm:mb-14">
          <h2 className="text-xl sm:text-xl lg:text-2xl font-bold text-gray-800 mb-4 max-w-4xl mx-auto leading-tight">
            Get Your Smart Phone,Feature Phone, Tablet, Smart Watch Repair
            Anytime, Anywhere!
          </h2>

          <div className="flex justify-center mb-6">
            <div className="w-20 h-1 bg-[#2563eb] rounded-full"></div>
          </div>

          <p className="text-sm sm:text-base text-gray-600 max-w-2xl mx-auto">
            1,00,000+ happy customers trust PhoneLab for fast, reliable doorstep repairs with certified technicians & warranty.
          </p>
        </div>

        {/* Categories Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4 sm:gap-5">
          {devices.map((device) => (
            <div
              key={device.deviceId}
              className="
bg-white rounded-2xl p-5 h-[180px]
shadow-[0_4px_20px_rgba(0,0,0,0.06)]
border border-gray-300
hover:border-[#2563eb]
hover:shadow-[0_12px_35px_rgba(0,0,0,0.12)]
transition-all duration-300 ease-out
hover:-translate-y-2 hover:scale-[1.03]
flex flex-col items-center justify-center text-center cursor-pointer
"
              onClick={() => {
                window.location.href = `/device/${device.deviceId}`;
              }}
            >
              <div className="mb-4 flex items-center justify-center">
                <img
                  src={device.imageBase64
                    ? `data:image/jpeg;base64,${device.imageBase64}`
                    : `https://via.placeholder.com/150?text=${device.deviceName}`}
                  alt={device.deviceName}
                  className="h-[80px] object-contain"
                  onError={(e) => {
                    (e.target as HTMLImageElement).src =
                      'https://via.placeholder.com/150?text=' + device.deviceName;
                  }}
                />
              </div>

              <h3 className="text-xs font-semibold text-gray-800 uppercase tracking-wide">
                {device.deviceName}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceCategories;